<template>
  <div class="subtable">
    <Table :columns="columns" :data="data" ></Table>
  </div>
</template>
<script>

  export default {
    props:{
      columns:{
        type:Array,
        default:function(){return []}
      },
      data:{
        type:Array,
        default:function(){return []}
      },
    },
  }
</script>

<style scoped>

</style>
